import { useEffect } from 'react'

import {
  useGetBookingAdventuresIndexLazyQuery,
  useGetBucketListItemsIndexLazyQuery,
} from '../../../hooks/useQueries'

/**
 * Makes use of lazy query by default, so will not load until predicate argument becomes truthy.
 *
 * Pass `true` to trigger query immediately.
 */
const useLazyEscapeIndexesQueries = (predicate: boolean) => {
  const [
    loadBucketListItemsIndex,
    {
      data: bucketListItemsIndexQueryData,
      loading: bucketListItemsIndexLoading,
    },
  ] = useGetBucketListItemsIndexLazyQuery()

  const [
    loadBookingAdventuresIndex,
    {
      data: bookingAdventuresIndexQueryData,
      loading: bookingAdventuresIndexLoading,
      updateQuery: updateBookingAdventuresIndexQuery,
    },
  ] = useGetBookingAdventuresIndexLazyQuery()

  useEffect(() => {
    if (predicate) {
      loadBucketListItemsIndex()
      loadBookingAdventuresIndex()
    }
  }, [predicate])

  const bucketListItemsIndex = bucketListItemsIndexQueryData?.currentUser
    ?.bucketListItemsIndex as GQL_BucketListItemsIndex

  const bookingAdventuresIndex = bookingAdventuresIndexQueryData?.currentUser
    ?.bookingAdventuresIndex as GQL_BookingAdventuresIndex

  return {
    bucketListItemsIndex,
    bucketListItemsIndexLoading,
    bookingAdventuresIndex,
    bookingAdventuresIndexLoading,
    updateBookingAdventuresIndexQuery,
  }
}

export default useLazyEscapeIndexesQueries
